<template>
  <div>
    <lcontainer class="mb-4">
      <div class="heading flex flex-row items-center justify-between py-2 px-8">
        <div>
          <div class="page text-white">Edit Lesson</div>
        </div>
        <div>
          <img
            class="md:h-24"
            :src="require('../../../assets/tenant_image.png')"
            alt=""
          />
        </div>
      </div>
    </lcontainer>
    <div class="bg-white px-2 py-4 ">
      <lCrumbs class=" px-8" :breadcrumb="breadcrumbItems" />

      <div class="bg-white px-2 py-4 ">
        <div
          class="flex flex-col md:flex-row xs:items-center md:justify-around"
        >
          <div class="w-11/12 md:w-2/5">
            <div class="form-row mb-8">
              <div class="mb-2 md:mb-0">
                <label class="modal-field font-semibold">Lesson Title:</label>
              </div>
              <div class="ml-auto">
                <linput
                  type="text"
                  name="fname"
                  v-model="form.title"
                  :errorMessage="errors.title"
                  :error="errors.title"
                  placeholder="Title of Lesson"
                />
              </div>
            </div>
            <div class="form-row mb-8">
              <div class="mb-2 md:mb-0">
                <label class="modal-field font-semibold ">Description:</label>
              </div>
              <div class="">
                <ltextarea
                  v-model="form.description"
                  :errorMessage="errors.description"
                  :error="errors.description"
                  placeholder="Lesson Description"
                />
              </div>
            </div>

            <div class="flex flex-row flex-wrap items-center form-row mb-8">
              <div class="modal-field font-semibold ">Skills To Be Gained:</div>
              <div class="flex-grow ml-auto">
                <ltextarea
                  v-model="form.skills_gained"
                  :errorMessage="errors.skills_gained"
                  :error="errors.skills_gained"
                  placeholder="Skills to be gained"
                />
              </div>
            </div>
            <div class="form-row mb-8">
              <div class="mb-2 md:mb-0">
                <label class="modal-field font-semibold"
                  >Lesson Type {{ form.lesson_type }}:</label
                >
              </div>
              <div class="">
                <lselect
                  @selected="loadResource($event)"
                  :error="errors.lesson_type"
                  v-model="form.lesson_type"
                  :editValue="form.lesson_type"
                  :errorMessage="errors.lesson_type"
                  :items="types"
                  placeholder="Select Lesson Type"
                />
              </div>
            </div>
            <div
              v-if="form.lesson_type === 'video'"
              class="flex flex-row flex-wrap items-center form-row mb-8"
            >
              <label class=" font-semibold">
                <input
                  v-model="admin_pool"
                  class=" leading-tight"
                  type="checkbox"
                />
                <span class="">
                  Fetch courses from Lesson Pool
                </span>
              </label>
            </div>
            <div v-if="showAssets && !admin_pool" class="form-row mb-8">
              <div class="mb-2 md:mb-0 modal-field font-semibold">
                Lesson Resource:
              </div>
              <div class="">
                <lselect
                  @selected="loadResource($event)"
                  selected
                  :error="errors.lesson_resource"
                  v-model="form.lesson_resource"
                  :errorMessage="errors.lesson_resource"
                  :editValue="form.lesson_resource"
                  :items="getResources"
                  placeholder="Select Resource"
                />
              </div>
            </div>
            <div v-if="admin_pool" class="form-row mb-8">
              <div class="modal-field font-semibold">Lesson Resource:</div>
              <div class="flex-grow ml-auto">
                <lselect
                  selected
                  :error="errors.lesson_resource"
                  v-model="form.lesson_resource"
                  :errorMessage="errors.lesson_resource"
                  :items="getLessonPool"
                  placeholder="Select Resource -Amdin"
                />
              </div>
            </div>
          </div>
          <div class="w-11/12 md:w-2/5">
            <div class="form-row mb-8">
              <div class="mb-2 md:mb-0">
                <label class="modal-field font-semibold">Cover Image:</label>
              </div>
              <div class="flex-grow ml-auto">
                <vue-dropzone
                  @vdropzone-drag-drop="
                    form.image = $event;
                    uploads = [''];
                  "
                  @vdropzone-file-added="
                    form.image = $event;
                    uploads = [''];
                  "
                  ref="myVueDropzone"
                  id="dropzone"
                  :options="dropzoneOptions"
                ></vue-dropzone>
              </div>
              <div class="mt-4 ">
                <img :src="form.image" class="h-20 mx-auto" alt="" />
              </div>
            </div>
            <div class="form-row mb-8">
              <div class="mb-2 md:mb-0">
                <label class="modal-field font-semibold ">Duration:</label>
              </div>
              <div class="flex-grow ml-auto">
                <linput
                  v-model="form.duration"
                  :error="errors.duration"
                  :errorMessage="errors.duration"
                  type="text"
                  placeholder="0"
                />
              </div>
            </div>
            <div class="form-row mb-8">
              <div class="mb-2 md:mb-0 modal-field font-semibold ">
                Lesson Number:
              </div>
              <div class="flex-grow ml-auto">
                <linput
                  v-model="form.lesson_number"
                  :error="errors.lesson_number"
                  :errorMessage="errors.lesson_number"
                  type="text"
                  placeholder="0"
                />
              </div>
            </div>
            <div class="form-row mb-8">
              <div class="mb-2 md:mb-0 modal-field font-semibold">
                Select Module
              </div>
              <div v-if="form.module_id" class="flex-grow ml-auto">
                <lselect
                  :error="errors.type"
                  v-model="id"
                  :editValue="form.module_id"
                  :items="getModules"
                  :errorMessage="errors.type"
                  placeholder="Select Module"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-col justify-center items-center">
          <div class="mb-2">
            <lms-button @click="handleFormSubmit">Update Lesson</lms-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import FormActions from "@/mixins/FormActions";
export default {
  mixins: [FormActions],
  data() {
    return {
      errors: [],
      showAssets: false,
      form: {},
      res: {},
      assets: [],
      id: "",
      uploads: [],
      admin_pool: false,
      breadcrumbItems: [
        {
          disabled: true,
          to: "back",
          text: "Single Module",
        },
        {
          disabled: true,
          to: `/tenant/lesson/edit/${this.$route.params.lesson_id}`,
          text: "Single Lesson",
        },
      ],
      types: [
        {
          text: "Video",
          value: "video",
        },
        {
          text: "Article",
          value: "article",
        },
        {
          text: "Exercise",
          value: "exercise",
        },
        {
          text: "Quiz",
          value: "quiz",
        },
        {
          text: "Survey",
          value: "survey",
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getTenantModules",
      "getTenantCourse",
      "getResources",
      "getLessonPool",
    ]),
    getModules() {
      let modules = this.getTenantModules;
      // //console.log({ modules });
      let sortedModules = [];
      for (let i = 0; i < modules.length; i++) {
        let temp = {
          text: modules[i].title,
          value: modules[i].id,
        };
        // //console.log(temp);
        sortedModules = sortedModules.concat(temp);
      }
      // //console.log(sortedModules);
      return sortedModules;
    },
  },
  async mounted() {
    this.updateLoader(true);
    this.form = {};
    if (this.$route.params.module) {
      this.id = this.$route.params.module;
    }
    this.fetchSingleTenantCourse({
      id: this.$route.params.id,
    });
    this.fetchAdminPool();

    let res = await this.tenantEditLesson({
      id: this.$route.params.lesson_id,
    });

    this.fetchTenantModules({ id: res.course_id });

    this.form = res;
    this.res = res;
    this.updateLoader(false);
  },

  methods: {
    ...mapMutations(["updateLoader"]),
    async uploader(file) {
      let imageUrl = await this.uploadFile(file);
      this.form.image = imageUrl;
    },
    async loadResource(e) {
      if (this.form.lesson_type == "video") {
        let res = await this.loadUserAssets();
      } else if (this.form.lesson_type == "article") {
        let res = await this.loadUserArticles();
      } else if (this.form.lesson_type == "quiz") {
        let res = await this.tenantFetchQuizForLesson();
      } else if (this.form.lesson_type == "exercise") {
        let res = await this.tenantFetchExerciseForLesson();
      } else if (this.form.lesson_type == "survey") {
        let res = await this.tenantFetchSurveys();
      }
      this.showAssets = true;
    },
    ...mapActions([
      "tenantEditLesson",
      "tenantUpdateLesson",
      "loadUserAssets",
      "fetchTenantModules",
      "loadUserArticles",
      "fetchSingleTenantCourse",
      "fetchTenantModuleCourses",
      "fetchTenantCourses",
      "fetchAdminPool",
      "tenantFetchQuizForLesson",
      "tenantFetchExerciseForLesson",
      "tenantFetchSurveys",
    ]),
    async handleFormSubmit() {
      this.errors = [];
      this.updateLoader(true);
      if (this.uploads.length > 0) {
        this.form.image = await this.uploadFile(this.form.image);
      }
      let res = await this.tenantUpdateLesson({
        course: this.$route.params.id,
        module: this.id,
        program: this.getTenantCourse.program_id,
        lesson: this.form,
      });
      this.updateLoader(false);

      if (res == true || res.status == 200 || res.status == 201) {
        this.form = {};
        this.fetchTenantCourses();
        this.$Bus.$emit("notify", {
          type: "success",
          message: "Lesson updated successfully",
        });

        this.$router.go(-1);
      } else {
        this.errors = res.data.errors[0].source;
        this.$Bus.$emit("notify", {
          type: "error",
          message: res.data.errors
            ? res.data.errors[0].title
            : "An error occured",
        });
      }
    },
    close() {
      this.form = {};
      this.$emit("closeLessonModal", false);
    },
  },
  components: {
    linput: () => import("@/components/general/input"),
    ltextarea: () => import("@/components/general/textarea"),
    LmsButton: () => import("@/components/general/button"),
    lselect: () => import("@/components/forms/select"),
    lCrumbs: () => import("@/components/general/breadcrumbs.vue"),
    lcontainer: () => import("@/components/general/container"),
  },
};
</script>
<style lang="scss" scoped>
.form-row {
  width: 100%;
}
.modal {
  z-index: 10;

  .overlay {
    background: #b1b3b9;
    opacity: 0.89;
    z-index: 0;
  }

  .modal-content {
    width: 100%;
    width: 1001px !important;

    .modal-title {
      font-size: 24px;
      color: color(lms-admin);
    }

    .modal-field {
      color: color(lms-admin);
      // max-width: calc(135px + 16px);
      width: 100%;
    }

    .close {
      background-color: #c2454b;
      height: 30px;
      width: 30px;
      border-radius: 50%;
      font-size: 12px;
      top: 0;
      z-index: 2;
      right: 0;
    }
    z-index: 1;
  }
}
</style>
